<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" placeholder="汽配编码、互换码"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                <div class="search-name">仓位类型</div>
                <div class="search-item goods-categories" style="width: 100px">
                    <el-select multiple size="small" style="width: 100%" v-model="searchData.SpaceType">
                        <el-option key="0" label="标准仓" value="0"></el-option>
                        <el-option key="1" label="临时仓" value="1"></el-option>
                        <el-option key="2" label="废品仓" value="2"></el-option>
                    </el-select>
                </div>
                <div class="search-name">仓库</div>
                <div class="search-item goods-categories" style="width: 120px">
                    <el-select
                        size="small"
                        style="width: 100%"
                        v-model="searchData.SId"
                        filterable
                        clearable
                        @visible-change="wHVisibleChange($event)"
                        @change="warehouseChange($event)"
                    >
                        <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name">仓位</div>
                <div class="search-item goods-categories" style="width: 120px">
                    <el-select
                        size="small"
                        style="width: 100%"
                        v-model="searchData.SSId"
                        reserve-keyword
                        remote
                        :remote-method="val => remoteMethod(val)"
                        v-select-scroll-more="remoteMethodScrollMore"
                        filterable
                        clearable
                        v-loading="spaceloading"
                    >
                        <el-option v-for="optionItem in spaceList" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId">
                            <div class="option-content">
                                <div>{{ optionItem.ShelfSpaceCode }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch" :readonly="saveLoading" style="margin-left: 10px"
                    >查询</el-button
                >
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="moreSearch" :readonly="saveLoading" style="margin-left: 10px"
                    >更多条件</el-button
                >
                <el-button size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportDataV2" :readonly="saveLoading"
                    >导出<span v-if="tableDataLength">（{{ tableDataLength }}）</span></el-button
                >
            </div>
        </div>
        <div class="table-ctn u-table-ctn" v-if="showTable">
            <u-table use-virtual :header-cell-style="{ background: '#F2F6FC' }" :border="true" :data="tableData" height="660" :row-height="34" style="width: 100%">
                <u-table-column label="汽配编码" show-overflow-tooltip min-width="200px" prop="APCode"></u-table-column>
                <u-table-column label="汽配名称" show-overflow-tooltip min-width="150px" prop="GoodName"></u-table-column>
                <u-table-column label="互换码" show-overflow-tooltip min-width="200px" prop="GoodCode"></u-table-column>
                <u-table-column label="适用车型" show-overflow-tooltip min-width="200px" prop="AutoSerise"></u-table-column>
                <u-table-column label="分类" show-overflow-tooltip min-width="100px" prop="Cate"></u-table-column>
                <u-table-column label="品牌" show-overflow-tooltip min-width="100px" prop="Brand"></u-table-column>
                <u-table-column label="单位" show-overflow-tooltip min-width="100px" prop="Unit"></u-table-column>
                <u-table-column label="销售数" show-overflow-tooltip width="100px" prop="SalesCount" v-if="searchData.SalesStartDate || searchData.SalesEndDate">
                </u-table-column>
                <u-table-column label="库存数" show-overflow-tooltip width="100px" prop="Inventory"></u-table-column>
                <u-table-column label="成本价" show-overflow-tooltip width="100px" prop="CostPrice"></u-table-column>
                <u-table-column label="批发价" show-overflow-tooltip width="100px" prop="WholePrice"></u-table-column>
                <u-table-column label="零售价" show-overflow-tooltip width="100px" prop="RetailPrice"></u-table-column>
                <!-- <u-table-column
                label="仓库"
                show-overflow-tooltip
                width="100px"
                prop="Warehouse"
                ></u-table-column>
                <u-table-column
                label="仓位"
                show-overflow-tooltip
                width="100px"
                prop="ShelfSpace"
                ></u-table-column>  -->
                <u-table-column label="产地" show-overflow-tooltip width="100px" prop="Origin"></u-table-column>
                <u-table-column label="尺寸" show-overflow-tooltip width="100px" prop="Size"></u-table-column>
                <u-table-column label="库存上限" show-overflow-tooltip width="100px" prop="UpperLimit"> </u-table-column>
                <u-table-column label="库存下限" show-overflow-tooltip width="100px" prop="LowerLimit"> </u-table-column>
                <u-table-column v-if="isShowPerf" label="绩效属性" show-overflow-tooltip width="100px" prop="PerSetName"> </u-table-column>
                <u-table-column v-if="isShowProject" label="合作项目" show-overflow-tooltip width="100px" prop="ProjectName"> </u-table-column>
            </u-table>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.Page"
                    :page-sizes="[200, 400, 600, 800, 1000]"
                    :page-size="searchData.Limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </div>
        <div class="no-data" v-else>请搜索商品</div>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
        <el-dialog :close-on-click-modal="false" title="搜索" :visible.sync="dialogVisible" width="400px">
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model.trim="searchData.APCode" placeholder="汽配编码、互换码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    </el-form-item>
                    <el-form-item label="品牌">
                        <el-select
                            v-model="searchData.BrandName"
                            filterable
                            clearable
                            :loading="loading"
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option label="全部" value></el-option>
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            :loading="loading"
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option label="全部" value></el-option>
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="仓位类型">
                        <el-select multiple size="small" style="width: 100%" v-model="searchData.SpaceType">
                            <el-option key="0" label="标准仓" value="0"></el-option>
                            <el-option key="1" label="临时仓" value="1"></el-option>
                            <el-option key="2" label="废品仓" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="仓库">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.SId"
                            filterable
                            clearable
                            @visible-change="wHVisibleChange($event)"
                            @change="warehouseChange($event)"
                        >
                            <el-option
                                v-for="optionItem in warehouseList"
                                :key="optionItem.WarehouseId"
                                :label="optionItem.WarehouseName"
                                :value="optionItem.WarehouseId"
                            >
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="仓位">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.SSId"
                            reserve-keyword
                            remote
                            :remote-method="val => remoteMethod(val)"
                            v-select-scroll-more="remoteMethodScrollMore"
                            filterable
                            clearable
                            v-loading="spaceloading"
                        >
                            <el-option v-for="optionItem in spaceList" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId">
                                <div class="option-content">
                                    <div>{{ optionItem.ShelfSpaceCode }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="成本价">
                        <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol3" clearable placeholder="符号">
                            <el-option key=">=" label=">=" value=">="></el-option>
                            <el-option key=">" label=">" value=">"></el-option>
                            <el-option key="<=" label="<=" value="<="></el-option>
                            <el-option key="<" label="<" value="<"></el-option>
                            <el-option key="=" label="=" value="="></el-option>
                            <el-option key="!=" label="!=" value="!="></el-option>
                            <el-option key="between" label="区间" value="between"></el-option>
                        </el-select>
                        <el-input
                            ref="search_12"
                            class="search-item"
                            size="small"
                            style="width: 90px"
                            v-model.trim="searchData.CostPrice1"
                            @focus="selectAutoHandle('search_12')"
                        ></el-input>
                        <el-input
                            class="search-item"
                            size="small"
                            style="width: 90px"
                            v-model.trim="searchData.CostPrice2"
                            v-if="searchData.Symbol3 == 'between'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="零售价">
                        <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol1" clearable placeholder="符号">
                            <el-option key=">=" label=">=" value=">="></el-option>
                            <el-option key=">" label=">" value=">"></el-option>
                            <el-option key="<=" label="<=" value="<="></el-option>
                            <el-option key="<" label="<" value="<"></el-option>
                            <el-option key="=" label="=" value="="></el-option>
                            <el-option key="!=" label="!=" value="!="></el-option>
                            <el-option key="between" label="区间" value="between"></el-option>
                        </el-select>
                        <el-input
                            ref="search_10"
                            class="search-item"
                            size="small"
                            style="width: 90px"
                            v-model.trim="searchData.MarketPrice1"
                            @focus="selectAutoHandle('search_10')"
                        ></el-input>
                        <el-input
                            class="search-item"
                            size="small"
                            style="width: 90px"
                            v-model.trim="searchData.MarketPrice2"
                            v-if="searchData.Symbol1 == 'between'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="批发价">
                        <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol2" clearable placeholder="符号">
                            <el-option key=">=" label=">=" value=">="></el-option>
                            <el-option key=">" label=">" value=">"></el-option>
                            <el-option key="<=" label="<=" value="<="></el-option>
                            <el-option key="<" label="<" value="<"></el-option>
                            <el-option key="=" label="=" value="="></el-option>
                            <el-option key="!=" label="!=" value="!="></el-option>
                            <el-option key="between" label="区间" value="between"></el-option>
                        </el-select>
                        <el-input
                            ref="search_11"
                            class="search-item"
                            size="small"
                            style="width: 90px"
                            v-model.trim="searchData.Price1"
                            @focus="selectAutoHandle('search_11')"
                        ></el-input>
                        <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Price2" v-if="searchData.Symbol2 == 'between'"></el-input>
                    </el-form-item>
                    <el-form-item label="创建日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="销售日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="salesTimes"
                            type="monthrange"
                            format="yyyy-MM"
                            value-format="yyyy-MM"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions2"
                            @change="onSalesTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch" :readonly="saveLoading" style="margin-left: 10px"
                        >查询</el-button
                    >
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            pageTitle: '导出Excel',
            showTable: false,
            loading: false,
            saveLoading: false,
            brandList: [],
            typeList: [],
            datetime1: [],
            salesTimes: [],
            searchData: {
                EntpId: userMsg.EntpId,
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                SpaceType: [],
                SId: '',
                SSId: '',
                Symbol1: '',
                MarketPrice1: 0,
                MarketPrice2: 0,
                Symbol2: '',
                Price1: 0,
                Price2: 0,
                Symbol3: '',
                CostPrice1: 0,
                CostPrice2: 0,
                StartDate: '',
                EndDate: '',
                SalesStartDate: '',
                SalesEndDate: '',
                Page: 1,
                Limit: 200
            },
            dialogVisible: false,
            tableDataLength: 0,
            tableData: [],
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            spaceloading: false,
            spaceList: [],
            warehouseList: [],
            currentShelfSpaceObj: {}, // 当前的下拉框仓位数据
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 335);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            pickerOptions2: {
                shortcuts: [
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            // 精确日期范围：从今天向前推三个月（包括起始和结束当天），结果取决于具体日期
                            // 今天2024年6月15日 → 2024年3月15日至2024年6月15日
                            // 包含的月份：以月份为单位的近三个月（包含当前月份）
                            // 今天2024年6月15日 → 2024年4月、5月、6月
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 335);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isShowPerf: false,
            isShowProject: false
        };
    },
    mounted() {
        this.getConfigByCodes();
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['qyzdyspsx', 'hzxmxzset'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'qyzdyspsx':
                                    this.isShowPerf = result;
                                    break;
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) {
                    that.loading = true;
                    that.$util
                        .searchGoodsBrand()
                        .then(data => {
                            that.brandList = data;
                            that.loading = false;
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                }
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) {
                    that.loading = true;
                    that.$util
                        .searchGoodsType()
                        .then(data => {
                            that.typeList = data;
                            that.loading = false;
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                }
            }
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        moreSearch() {
            this.dialogVisible = true;
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        // 获取数据
        getTableData() {
            this.exportSuccess = false;
            this.$util
                .axiosPost({
                    // url: '/api/EntpGoods/GetGoodsListForExport',
                     url: '/api/EntpGoods/GetGoodsListForExport_V2',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    if(this.searchData.Page == 1)
                        this.tableDataLength=res.count;
                    this.tableData = data;
                    this.showTable = true;
                })
                .catch(() => {
                    this.showTable = true;
                });
            // if (this.searchData.Page == 1) {
            //     this.getDataCount();
            // }
        },
        getDataCount() {
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetExportGoodsCount',
                    data: this.searchData
                })
                .then(res => {
                    let count = res.data;
                    this.tableDataLength = count;
                })
                .catch(() => {});
        },
        resetSearch() {
            let userMsg = this.$util.getLocalStorage('userMsg');
            this.searchData = {
                EntpId: userMsg.EntpId,
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                SpaceType: [],
                SId: '',
                SSId: '',
                Symbol1: '',
                MarketPrice1: 0,
                MarketPrice2: 0,
                Symbol2: '',
                Price1: 0,
                Price2: 0,
                Symbol3: '',
                CostPrice1: 0,
                CostPrice2: 0,
                StartDate: '',
                EndDate: '',
                SalesStartDate: '',
                SalesEndDate: '',
                Page: 1,
                Limit: 200
            };
            this.datetime1 = [];
            this.salesTimes = [];
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选商品');
                return;
            }
            that.saveLoading = true;
            // //每次取100条数据
            let saveLimit = 100;
            if (that.tableDataLength > 20000) saveLimit = 20000;
            else saveLimit = that.tableDataLength;

            let reqData = { ...that.searchData, UId: that.userMsg.EmployeeId };
            reqData.Page = that.currtPage;
            reqData.Limit = saveLimit;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/ExportEntpGoods',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;

                    if (that.tableDataLength <= that.saveCount) {
                        setTimeout(function () {
                            that.$util.successMsg('导出成功');
                            that.saveLoading = false;
                            that.tableData = [];
                            that.tableDataLength = 0;
                            that.showTable = false;

                            that.percentage = 0;
                            that.saveCount = 0;
                            that.currtPage = 1;
                            that.$util.exportFile({
                                url: '/api/EntpGoods/ExportEntpGoods',
                                data: {
                                    uid: that.userMsg.EmployeeId,
                                    salesStartDate: that.searchData.SalesStartDate,
                                    salesEndDate: that.searchData.SalesEndDate,
                                    sId: that.searchData.SId
                                }
                            });
                        }, 1000);
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                });
        },
        exportDataV2() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选商品');
                return;
            }
            // that.saveLoading = true;
            // //每次取100条数据
            let saveLimit = 100;
            if (that.tableDataLength > 20000) saveLimit = 20000;
            else saveLimit = that.tableDataLength;

            let reqData = { ...that.searchData, UId: that.userMsg.EmployeeId };
            reqData.Page = that.currtPage;
            reqData.Limit = saveLimit;
            that.$util
                .exportFile_post({
                    url: '/api/EntpGoods/ExportEntpGoods_v2',
                    data: reqData
                })
                .then(res => {
                    // that.saveLoading = false;
                    that.$util.successMsg('导出成功');
                });
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        warehouseChange(value) {
            this.spaceList = [];
            this.searchData.SSId = '';
            if (value) {
                this.currentShelfSpaceObj = { Page: 1, StopLoad: false };
                this.searchPosition(this.currentShelfSpaceObj);
            }
        },
        // 仓位下拉框滚动加载
        remoteMethodScrollMore() {
            this.remoteMethod();
        },
        /**
         * 搜索仓位
         * 支持远程搜索和滚动下拉加载更多
         *   通过 val 判断是哪种情况，非空时是远程搜索
         */
        remoteMethod(val) {
            let obj = this.currentShelfSpaceObj;
            if (val) {
                // 远程搜索，重置搜索项
                obj.Key = val;
                obj.Page = 1;
                obj.StopLoad = false;
                this.spaceList = [];
            } else {
                // 下拉加载更多
                obj.Page += 1;
            }
            if (obj.StopLoad) return;
            this.searchPosition({
                Key: obj.Key,
                Page: obj.Page
            }).then(() => {
                let row = {
                    ...obj
                    // StopLoad: this.spaceList.length < 20
                };
                this.currentShelfSpaceObj = row;
            });
        },
        // 搜仓位
        searchPosition(obj) {
            let that = this;
            if (!that.searchData.SId || that.spaceloading) return;
            that.spaceloading = true;
            return that.$util
                .GetShelfSpacesList({
                    WarehouseId: that.searchData.SId,
                    ShelfSpaceCode: obj.Key,
                    Page: obj.Page,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: true
                })

                .then(res => {
                    that.spaceloading = false;
                    if (res.data) {
                        that.spaceList = that.spaceList.concat(res.data);
                        this.currentShelfSpaceObj.StopLoad = that.spaceList.length >= res.count;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.spaceloading = false;
                });
        },
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onSalesTimeSelect(val) {
            if (val != null) {
                this.searchData.SalesStartDate = val[0];
                this.searchData.SalesEndDate = val[1];
            } else {
                this.searchData.SalesStartDate = '';
                this.searchData.SalesEndDate = '';
            }
        }
    }
};
</script>
<style lang="less" scoped>
.explain {
    flex-shrink: 0;
    margin: 0 10px 10px;
    height: 32px;
    line-height: 32px;
    color: #ef7a82;
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
.mb0 {
    margin-bottom: 0 !important;
}
.el-form-item {
    margin-bottom: 0px !important;
}
.dialog-footer {
    text-align: right;
}
</style>
